<template>
  <div class="fixed top-0 left-0 z-50 w-screen h-screen bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white p-8 rounded-lg shadow-lg w-96">
        <div class="flex items center justify-center">
          <svg class="animate-spin h-10 w-10 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-95" fill="currentColor" d="M4 8a8 8 0 018-8V2.5"></path>
          </svg>
          <p class="text-lg m-auto ml-4 rn-style">{{ message }}</p>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingBar',
  props: {
    message: {
      type: String,
      required: false,
    },
  },
}
</script>
<style scoped>
.rn-style {
  font-family: 'Electrolize';
}</style>